import React from 'react';

export default function StaffAugmentationIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.6567 8.84829L15.5609 3L0 5.8663L2.8903 21.2981L8.50211 20.2643L8.27749 24.0856L24.0779 25L25 9.33072L16.6567 8.84829Z"
        fill="#F66135"
      />
      <path d="M9.08057 8.52795L25.3987 9.42126L24.5054 25.7393L8.18726 24.846L9.08057 8.52795Z" fill="#FBB39E" />
    </svg>
  );
}
